var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrolToDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41 41",
    width: 41,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".prefix__prefix__shp1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.2}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__prefix__Group_15739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__prefix__Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Ellipse_1572-2",
    d: "M20.5 40.1C9.66 40.1.9 31.34.9 20.5.9 9.66 9.66.9 20.5.9c10.84 0 19.6 8.76 19.6 19.6 0 10.84-8.76 19.6-19.6 19.6z",
    fill: "#a1a3a3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__prefix__caret-double-down-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_13820",
    className: "prefix__prefix__shp1",
    d: "M27.45 20.93l-6.52 6.52-6.51-6.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__Path_13821",
    className: "prefix__prefix__shp1",
    d: "M27.45 14.42l-6.52 6.51-6.51-6.51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrolToDown);
export default __webpack_public_path__ + "static/media/scrol-to-down.0e8b3bfa.svg";
export { ForwardRef as ReactComponent };